export default function createEndpointPath<T extends { [key: string]: string | number | undefined }>(
	path: string,
	queryParams?: string,
) {
	return (pathParams?: T, { withRequiredQueryParams }: { withRequiredQueryParams?: boolean } = {}) => {
		const pathWithParams = Object.entries(pathParams ?? {}).reduce(
			(resultPath, [key, value]) => resultPath.replace(new RegExp(`:${key}\\??`), String(value)),
			path,
		);
		return `${pathWithParams}${withRequiredQueryParams && queryParams ? queryParams : ''}`;
	};
}
